// extracted by mini-css-extract-plugin
export var content = "_pf-1";
export var fullScreen = "_pf-0";